import cn from 'classnames';
import BaseLogo from '@dealroadshow/uikit-logo/BaseLogo';
import { ILogoProps } from '@dealroadshow/uikit-logo/types';

import creditflowresearchLogo from './creditflowresearch.inline.svg?raw';
import styles from '../styles.module.scss';

export const LogoCreditFlowResearchStandart = (props: ILogoProps) => (
  <BaseLogo
    { ...props }
    logoSvg={ creditflowresearchLogo }
    className={ cn(styles.logoCreditflowresearch, props.className) }
  />
);
